import * as React from "react"
import {Skeleton} from "@mui/material";

import {useUserApp} from "@hooks";
import { TitleWithPopover, AppTableSeeker } from "@components";
import {isLoadingCommonFilters} from "@signals";
import {sellerProductDetailsData} from "../@signals";
import MarketplacesSellerProductDetailsToggleButton from "../DetailsToggle";
import { stockColumn, numberColumn, imageSkuColumn, percentageColumn, skuColumn } from "./columns"


const HEIGHT = 500

export default function MarketPlacesProductDetailsTable() {
	const { userUseRRSP } = useUserApp()
	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!sellerProductDetailsData.value.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Marketplaces - Product details" />}
		data={sellerProductDetailsData.value}
		columns={[
			imageSkuColumn(),
			skuColumn(),
			numberColumn('numSellers', 'Nº Sellers'),
			numberColumn('numOffers', 'Nº Offers'),
			percentageColumn('discount', 'Discount'),
			...userUseRRSP ? [percentageColumn('priceDispersion', 'Price dispersion\nvs RRSP', 2)] : [],
			stockColumn()
		]}
		options={{
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPageOptions: [5, 10],
			customToolbar: () => <MarketplacesSellerProductDetailsToggleButton />
		}}
	/>
}